module.exports = __webpack_public_path__ + "img/food_item_1.39555360.png";